import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../../lib/api';
import { useAuth } from '../../../contexts/AuthContext';

const inp = 'border border-slate-300 rounded-lg px-2.5 py-1.5 text-sm';

// Owner console: how much a referral is worth to each side.
export default function ReferralProgram() {
  const { authHeader } = useAuth();
  const [p, setP] = useState(null);
  const [msg, setMsg] = useState('');
  useEffect(() => { axios.get(`${API}/platform/referral-program`, { headers: authHeader() }).then((r) => setP(r.data)).catch(() => {}); }, []); // eslint-disable-line
  if (!p) return null;
  const save = async () => {
    setMsg('');
    try {
      const { data } = await axios.put(`${API}/platform/referral-program`, { ...p, new_percent: Number(p.new_percent), referrer_percent: Number(p.referrer_percent), months: Number(p.months) }, { headers: authHeader() });
      setP(data); setMsg('Referral rewards saved.');
    } catch (e) { setMsg(typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Check the numbers (0–90%).'); }
  };
  return (
    <section className="bg-white border border-slate-200 rounded-2xl p-5 space-y-3" data-testid="referral-program">
      <div>
        <h2 className="font-semibold">Referral rewards</h2>
        <p className="text-xs text-slate-500 mt-0.5">Every workshop has its own code in Settings → Refer &amp; Earn. The referrer's reward is added once the new workshop makes its first payment, and comes off the referrer's next payment link.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <label className="inline-flex items-center gap-2"><input type="checkbox" checked={p.enabled} onChange={(e) => setP({ ...p, enabled: e.target.checked })} data-testid="referral-enabled" /> On</label>
        · New workshop gets
        <input type="number" value={p.new_percent} onChange={(e) => setP({ ...p, new_percent: e.target.value })} className={`${inp} w-16`} data-testid="referral-new-percent" />% for
        <input type="number" value={p.months} onChange={(e) => setP({ ...p, months: e.target.value })} className={`${inp} w-16`} data-testid="referral-months" />months · Referrer gets
        <input type="number" value={p.referrer_percent} onChange={(e) => setP({ ...p, referrer_percent: e.target.value })} className={`${inp} w-16`} data-testid="referral-referrer-percent" />% off next payment
        <button type="button" onClick={save} className="text-xs font-semibold px-3 py-2 rounded-lg" style={{ backgroundColor: '#0f172a', color: '#fff' }} data-testid="referral-save">Save</button>
      </div>
      {msg && <p className="text-xs text-slate-600" data-testid="referral-msg">{msg}</p>}
    </section>
  );
}
